import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { GetQueryParams } from '../types/api.type';
import {
  ListFilterSearchOptions,
  listFiltersToSearchParams,
  parseListFiltersFromSearch,
  searchParamsEqual
} from '../utils/listFilterSearchParams';

/**
 * Keeps list filter state in sync with the URL so browser back/forward restores filters.
 * Writes with replace:true so applying filters does not spam history entries.
 */
export const useListFiltersInUrl = (
  defaults: GetQueryParams,
  options?: ListFilterSearchOptions
): [GetQueryParams, Dispatch<SetStateAction<GetQueryParams>>] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState<GetQueryParams>(() =>
    parseListFiltersFromSearch(searchParams.toString(), defaults, options)
  );

  useEffect(() => {
    const next = listFiltersToSearchParams(filters, options);
    if (!searchParamsEqual(searchParams, next)) {
      setSearchParams(next, { replace: true });
    }
  }, [filters, options?.omitScopeFromUrl, searchParams, setSearchParams]);

  return [filters, setFilters];
};
